export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC',
}
